'use client';
import { isFunction, noop } from '@s7/utils';

/**
 * Создает обработчик событий клавиш, который выполняет действие при нажатии клавиши Escape.
 * Если опция `active` установлена в `false`, возвращает функцию-заглушку или пользовательскую обработку события `onKeyDown`.
 *
 * @param {Function?} action - Действие, выполняемое при нажатии клавиши Escape.
 * @param {CloseOnEscapeOptions} options - Опции для настройки поведения.
 *
 * @returns Обработчик события keydown.
 *
 * @primaryExample
 * const handleEscape = (event) => { /* логика закрытия *\/ };
 * const options = {
 *     active: true,
 *     onTrigger: () => { console.log('Закрытие выполнено'); }
 * };
 * document.addEventListener('keydown', closeOnEscape(handleEscape, options));
 * // Нажатие клавиши Escape вызовет `handleEscape` и затем `onTrigger`
 */ const closeOnEscape = (action, options = {
    active: true
})=>{
    if (!isFunction(action) || !options.active) {
        return options.onKeyDown || noop;
    }
    return (event)=>{
        if (event.key === 'Escape') {
            action(event);
            options.onTrigger == null ? void 0 : options.onTrigger.call(options);
        }
    };
};

export { closeOnEscape };
//# sourceMappingURL=closeOnEscape.js.map
